import '../DeckNav.css';
import { NativeNumbersDeckFace } from '../../DeckCardOverviews/BasicWords/NumbersOv';
import { SinoNumbersDeckFace } from '../../DeckCardOverviews/BasicWords/NumbersOv';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import ResourceBar from '../../Components/Resource/ResourceBar';
import Footer from '../../Components/Footer/Footer';


export default function NumbersNav() {
  return (
<div>
  <SPLoader time={0.6}/>
  <HeaderNav GoBack_to={"/BasicWordsNav"}/>
  <h1 className="DeckTitle-nav">Numbers (숫자)</h1>
  <ResourceBar DeeperLook_to="/NumbersDLook" Dictionary_to="/NumbersDictionary"/>
  <h1 className="Header2-nav">Flashcards</h1>
   <div><DeckNav faceCard={NativeNumbersDeckFace} title_input="Native Korean Numbers (고유어 수)"/> </div>
   <div><DeckNav faceCard={SinoNumbersDeckFace} title_input="Sino Korean Numbers (한자어 수)"/> </div>
   <Footer/>
</div>
  )
}